import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import ConfirmForm from './components/ConfirmForm';
import API from '../../services/API';
import Icon from "../../components/Icon";
import SyncMessage from "../../components/SyncMessage";

class AdkFeeds extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isShowForm: false,
            feedToUpdate: null,
            feedToRemove: null,
            sortParam: null,
            sortOrder: 1,
            feeds: [],
            types: [],
            partners: {},
            syncData: null
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleUpdateBtnClick = this.handleUpdateBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleConfirmFormHide = this.handleConfirmFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleSync = this.handleSync.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }

    componentDidMount() {
        this.loadFeeds();
        this.loadPartners();

        API.AdkLinks.getTypes().then(types => this.setState({ types }));
    }

    componentWillUpdate(nextProps, nextState) {
        const { feeds, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(feeds, sortParam, sortOrder);

            this.setState({ feeds });
        }
    }

    sortReport(feeds, sortParam, sortOrder) {
        feeds.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    loadPartners() {
        API.AdkPartners.get().then(partners => {
            partners = partners.reduce((obj, { id, name }) => {
                obj[id] = name;

                return obj;
            }, {})

            this.setState({ partners });
        });
    }

    loadFeeds() {
        this.setState({ isLoading: true });

        API.AdkFeeds.get().then(feeds => this.setState({ feeds, isLoading: false }));
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, feedToUpdate: null });
    }

    handleConfirmFormHide() {
        this.setState({ feedToRemove: null });
    }

    handleFormSubmit(feed) {
        this.setState({
            isShowForm: false,
            isLoading: true,
            feedToUpdate: null
        });

        if(feed.update) {
            const { id } = feed;

            delete feed.id;

            API.AdkFeeds.update(id, feed).then(() => this.loadFeeds());
        }
        else API.AdkFeeds.save(feed).then(() => this.loadFeeds());
    }

    handleUpdateBtnClick(feed) {
        this.setState({ isShowForm: true,  feedToUpdate: feed });
    }

    handleRemoveBtnClick(id) {
        this.setState({ feedToRemove: id });
    }

    handleRemove() {
        const { feedToRemove } = this.state;

        this.setState({ isLoading: true, feedToRemove: null });

        API.AdkFeeds.remove(feedToRemove).then(() => this.loadFeeds());
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync([ 'adk-EU', 'adk-US', 'adk-SG' ], 'feeds')
            .then((res) => {
                this.setState({ isLoading: false, syncData: { res } });

                setTimeout(() => this.setState({ syncData: null }), 10000);
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
                setTimeout(() => this.setState({ syncData: null }), 10000);
            });
    }

    getForm() {
        if(this.state.isShowForm) {
            return <Form
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide}
                feed={this.state.feedToUpdate}
                types={this.state.types}
                partners={this.state.partners}
            />;
        }
    }

    getConfirmForm() {
        if(this.state.feedToRemove) {
            return <ConfirmForm
                onFormHide={this.handleConfirmFormHide}
                onConfirm={this.handleRemove}
                feed={this.state.feedToRemove}
            />;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="ADK Feeds"/>
                <Row>
                    <Col lg={12}>
                        <div className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        </div>
                    </Col>
                </Row>
                <SyncMessage {...this.state.syncData} />
                {this.getForm()}
                {this.getConfirmForm()}

                <Table feeds={this.state.feeds} partners={this.state.partners} onRemove={this.handleRemoveBtnClick} onUpdate={this.handleUpdateBtnClick} handleFormSubmit={this.handleFormSubmit} onSort={this.handleSort}/>
            </Container>
        );
    }
}

export default AdkFeeds;



// WEBPACK FOOTER //
// ./src/scenes/AdkFeeds/index.js